"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.AppProviders = void 0;

var _react = _interopRequireDefault(require("react"));

var _breadcrumbContext = require("./breadcrumb-context");

var _optionsContext = require("./options-context");

/* eslint-disable import/no-extraneous-dependencies */

/* eslint-disable import/prefer-default-export */

/* eslint-disable react/prop-types */
var AppProviders = function AppProviders(_ref) {
  var element = _ref.element,
      pluginOptions = _ref.pluginOptions;
  var defaultCrumb = pluginOptions.defaultCrumb,
      useClassNames = pluginOptions.useClassNames,
      useAutoGen = pluginOptions.useAutoGen,
      usePathPrefix = pluginOptions.usePathPrefix;
  return /*#__PURE__*/_react.default.createElement(_optionsContext.OptionsProvider, {
    useAutoGen: useAutoGen || false,
    useClassNames: useClassNames || false,
    usePathPrefix: usePathPrefix || null
  }, /*#__PURE__*/_react.default.createElement(_breadcrumbContext.BreadcrumbProvider, {
    defaultCrumb: defaultCrumb || null
  }, element));
};

exports.AppProviders = AppProviders;